module.exports = __webpack_public_path__ + "img/sz.2591a51f.svg";